import React, { Component } from 'react'

import Navbar from '../Components/NavBar'
import ContactUs from '../Components/ContactUs'
import Footer from '../Components/Footer'

export class ContactUsPage extends Component {
  render() {
    return (
      <div>
        <Navbar/>
        <ContactUs/>
        <Footer/>
      </div>
    )
  }
}

export default ContactUsPage
